export const chevronDownPath = "<path d=\"M4 6 L8 10 L12 6\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>"
